import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";


import * as messageAction from "../../../../../actions/Message";
import { useSocket } from "../../../../../Context/SockerContext";

const BlockModal = ({ personId, show, setShow }) => {
  const navigate = useNavigate();
  const { socket } = useSocket();

  async function block() {
    const response = await messageAction.blockMatches({ personId: personId });
    if (response) {
      socket?.emit("leave-room", sessionStorage.getItem("conversationId"));
      navigate("/user/chat/matches");
    }
  }

  return (
    <Modal
      className="customer-modal-without-header-footer"
      size="sm"
      centered
      show={show}
    >
      <Modal.Body>
        <p
          style={{
            fontSize: "20px",
            fontWeight: "600",
            margin: "0",
            marginBottom: "1rem",
            color: "#6c6c6c",
          }}
        >
          Block user
        </p>
        <p
          style={{
            fontSize: "16px",
            margin: "0",
            textAlign: "center",
            color: "#6c6c6c",
          }}
        >
          Blocked members will no longer be able to message you and won't show
          up when you're browsing
        </p>
        <div
          style={{
            marginTop: "3rem",
            display: "flex",
            gap: "1rem",
            marginInline: "auto",
          }}
        >
          <button
            type="button"
            className="global-cancel-button"
            onClick={() => setShow(false)}
          >
            Close
          </button>
          <button onClick={block} className="global-save-button">Submit</button>
        </div>
      </Modal.Body>
    </Modal >
  );
}

export default BlockModal